import * as angular from 'angular';
import { IController } from 'angular';
import { IStateService } from 'angular-ui-router';
import * as _ from 'lodash';

import { SdcActionsService } from './../../../sdc/flux/sdc-actions.service';

export class SchoolPickerAutoCompleteCtrl implements IController {
  static $inject = ['$state', 'sdcActions'];

  // Bindings
  private items;

  public mappedItems;

  constructor(private $state: IStateService, private sdcActions: SdcActionsService) {}

  $onInit() {
    const mapped = this.items.map(item => {
      item.displayInfo = `${item.fullName} (${item._id})`;
      return item;
    });

    const sorted = _.sortBy(mapped, 'displayInfo');

    this.mappedItems = sorted;
  }

  // Functions
  selectedItemChange(item) {
    if (!item) return;
    this.sdcActions.resetCurrentSdcState();
    this.$state.go('main.school.home', { schoolId: item._id }, { reload: false });
  }
}

angular.module('nv-data-tools-portal').controller('schoolPickerAutoCompleteController', SchoolPickerAutoCompleteCtrl);
